import { useContext, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import './styles.css';
import styles from '../FormProduto/styles.module.scss';
import ReactSelect from '../../../data/reactSelect';
import { ProdutoContext } from '../../../../context/product';
import OptionsReactSelect from '../../../../interfaces/OptionsReactSelect';
import Layout from '../../../data/Layout';
import { AppDispatch, useAppSelector } from '../../../../redux/store';
import * as S from '../styled';
import { InputDefault } from '../../../data/inputDefault';
import InputCheckRadio from '../../../data/inputCheckRadio';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { useDispatch } from 'react-redux';
import { normalizeDescricao } from '../../../../utils/normalizeCaracters';
import Globals from '../../../../Globals.json';
import { useQueryFetchPages } from '../../../../apiQuery/useQueryFetchPages';
import { useQueryNcmByCodeOrDes } from '../../../../apiQuery/useQueryNcmByCodeOrDes';
import { IProduct } from '../../../../interfaces/IProduct';
import { getValueFrom } from '../../../../utils/getValueFrom';
import { getIdFrom } from '../../../../utils/getIdFrom';
import { getBoolFrom } from '../../../../utils/getBoolFrom';
import { ICategories } from '../../Categorias/interface/ICategories';
import { ICategorie } from '../../../../redux/features/inventary/interface';
import NcmSelect from '../../../data/NcmSelect';

export default function InfoFiscais({
  isEdit,
  isDupli,
  product,
}: {
  isEdit: any;
  isDupli: any;
  product: IProduct;
}) {
  const {
    taxProfile,
    setTaxProfile,
    stateOrigin,
    setStateOrigin,
    stateDestiny,
    setStateDestiny,
    types,
    setTypes,
    origins,
    setOrigins,
    ncm,
    setNcm,
    cest,
    setCest,
    cfop,
    setCfop,
    customer,
    setCustomer,
    icms,
    setIcms,
    ipi,
    setIpi,
    cstReasons,
    setCstReasons,
    pis,
    setPis,
    weight,
    setWeight,
    aliquot,
    setAliquotIcms,
    mva,
    setMva,
    reduction,
    setReduction,
    icmsAliquotDeferral,
    setIcmsAliquotDeferral,
    icmsCredit,
    setIcmsCredit,
    aliquotIpi,
    setAliquotIpi,
    aliquotPis,
    setAliquotPis,
    aliquotCofins,
    setAliquotCofins,
    validNcm,
    validCfop,
    validIcms,
    validAliquot,
    validAliquotIpi,
    validIpi,
    validPis,
    validAliquotPis,

    category,
    setCofins,
    cofins,
    validCofins,
    validcstReasons,
    selfService,
    setXdPrinters,
    setSelfService,
    setXdFollowItem,
    ncm_origin,
    setNcm_origin,
    setVisible_falimix,
    setVisible_autoplu,
    setVisible_delivery,
    setVisible_xd_orders,
    setVisible_online,
    setVisible_digital_menu,
    setXdRequestQty,
    setXdRequestPriceWhenZero,
    setXdBalanceQty,
    setXdOrderGrouped,
    setXdBillGroup,
    setXdAddTips,
    setXdExcludeMinimumConsumption,
    setXdBook,
    setCategoriesComplement,
    setAssociatedComplement,
    setLoading,
    loading,
    visible_autoplu,
  } = useContext(ProdutoContext);
  
  const dispatch = useDispatch<AppDispatch>();
  const storeMe = useAppSelector(({ storeMeReducer }) => storeMeReducer.value);
  
  const {
    data: categories,
    isLoading: isLoadingCategories,
    isError: isErrorCategories,
  } = useQueryFetchPages<any>(
    ['categories'],
    `${Globals.api.categoriesCompleted}/minified`,
    {
      queryParams: {
        store_id: storeMe?.storeActive?.id,
        paginate: false,
      },
    }
  );
  
  const {
    data: taxProfiles,
    isLoading: isLoadingTaxProfile,
    isError: isErrorTaxProfile,
  } = useQueryFetchPages<any>(['taxProfile'], `${Globals.api.taxProfile}`, {
    queryParams: {
      store_id: storeMe?.storeActive?.id,
      paginate: false,
    },
  });
  
  const {
    data: states,
    isLoading: isLoadingStates,
    isError: isErrorStates,
  } = useQueryFetchPages<any>(['states'], `${Globals.api.states}`, {
    queryParams: {
      store_id: storeMe?.storeActive?.id,
      paginate: false,
    },
  });
  
  const {
    data: invoiceTypes,
    isLoading: isLoadingInvoiceTypes,
    isError: isErrorInvoiceTypes,
  } = useQueryFetchPages<any>(
    ['invoiceTypes'],
    `${Globals.api.taxes}/invoices-types`,
    {
      queryParams: {
        paginate: false,
      },
    }
  );
  
  const {
    data: cstOrigins,
    isLoading: isLoadingCstOrigins,
    isError: isErrorCstOrigins,
  } = useQueryFetchPages<any>(
    ['cstOrigins'],
    `${Globals.api.taxes}/cst-origins`,
    {
      queryParams: {
        paginate: false,
      },
    }
  );

  const {
    data: cests,
    isLoading: isLoadingCests,
    isError: isErrorCests,
  } = useQueryFetchPages<any>(['cests'], `${Globals.api.taxes}/cests`, {
    queryParams: {
      paginate: false,
    },
  });
  
  const {
    data: cfops,
    isLoading: isLoadingCfops,
    isError: isErrorCfops,
  } = useQueryFetchPages<any>(['cfops'], `${Globals.api.taxes}/cfop`, {
    queryParams: {
      paginate: false,
    },
  });
  
  const {
    data: icmsCustomerTypes,
    isLoading: isLoadingIcmsCustomerTypes,
    isError: isErrorIcmsCustomerTypes,
  } = useQueryFetchPages<any>(
    ['icmsCustomerTypes'],
    `${Globals.api.taxes}/icms-customer-types`,
    {
      queryParams: {
        paginate: false,
      },
    }
  );
  
  const {
    data: cstReasonsList,
    isLoading: isLoadingCstReasons,
    isError: isErrorCstReasons,
  } = useQueryFetchPages<any>(
    ['cstReasons'],
    `${Globals.api.taxes}/cst-reasons`,
    {
      queryParams: {
        paginate: false,
      },
    }
  );

  // ========================================
  // QUERIES SEPARADAS PARA CADA TIPO DE CST
  // ========================================
  
  // CSTs de ICMS
  const {
    data: cstsIcms,
    isLoading: isLoadingCstsIcms,
    isError: isErrorCstsIcms,
  } = useQueryFetchPages<any>(
    ['csts-icms'],
    `${Globals.api.taxes}/csts`,
    {
      queryParams: {
        store_id: storeMe?.storeActive?.id,
        paginate: false,
        type: 'ICMS',
      },
    }
  );


  // CSTs de CSOSN
  const {
    data: cstsCSOSN,
    isLoading: isLoadingCstsCSOSN,
    isError: isErrorCstsCSOSN,
  } = useQueryFetchPages<any>(
    ['csts-CSOSN'],
    `${Globals.api.taxes}/csts`,
    {
      queryParams: {
        store_id: storeMe?.storeActive?.id,
        paginate: false,
        type: 'CSOSN',
      },
    }
  );

  // CSTs de IPI
  const {
    data: cstsIpi,
    isLoading: isLoadingCstsIpi,
    isError: isErrorCstsIpi,
  } = useQueryFetchPages<any>(
    ['csts-ipi'],
    `${Globals.api.taxes}/csts`,
    {
      queryParams: {
        store_id: storeMe?.storeActive?.id,
        paginate: false,
        type: 'IPI',
      },
    }
  );

  // CSTs de PIS
  const {
    data: cstsPis,
    isLoading: isLoadingCstsPis,
    isError: isErrorCstsPis,
  } = useQueryFetchPages<any>(
    ['csts-pis'],
    `${Globals.api.taxes}/csts`,
    {
      queryParams: {
        store_id: storeMe?.storeActive?.id,
        paginate: false,
        type: 'PIS',
      },
    }
  );

  // CSTs de COFINS
  const {
    data: cstsCofins,
    isLoading: isLoadingCstsCofins,
    isError: isErrorCstsCofins,
  } = useQueryFetchPages<any>(
    ['csts-cofins'],
    `${Globals.api.taxes}/csts`,
    {
      queryParams: {
        store_id: storeMe?.storeActive?.id,
        paginate: false,
        type: 'COFINS',
      },
    }
  );

  // Listas separadas para cada tipo
  const CSOSNList = cstsCSOSN?.data || [];
  const icmsList = cstsIcms?.data || [];
  const ipisList = cstsIpi?.data || [];
  const pisList = cstsPis?.data || [];
  const cofinsList = cstsCofins?.data || [];

  const [cestListObject, setCestListObject] = useState<OptionsReactSelect[]>(
    []
  );

  const [icmsOpen, setIcmsOpen] = useState<boolean>(
    isDupli !== undefined || isEdit !== undefined
  );
  
  const clearInfoFicais = () => {
    setCest(undefined);
    setTypes(undefined);
    setOrigins(undefined);
    setIcms(undefined);
    setNcm(undefined);
    setCfop(undefined);
    setStateOrigin(undefined);
    setStateDestiny(undefined);
    setCustomer(undefined);
    setIpi(undefined);
    setCstReasons(129);
    setPis(undefined);
    setCofins(undefined);
    setWeight('0');
    setAliquotIcms('0');
    setMva('0');
    setReduction('0');
    setAliquotIpi('0');
    setAliquotPis('0');
    setAliquotCofins('0');
    setIcmsAliquotDeferral('0');
    setIcmsCredit('0');
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const completeTaxProfileInformationTax = (tax: any) => {
    const selectedTaxProfile = taxProfiles?.data?.find(
      (item: any) => item.id === tax
    );

    setIfoFiscaisPerfil(selectedTaxProfile);
  };

  const setIfoFiscaisPerfil = (list: any) => {
    setCest(list?.relationships?.cest?.id);
    setTypes(list?.relationships?.tax_invoice_type?.id);
    setOrigins(list?.relationships?.cst_origin?.id);
    setIcms(list?.relationships?.cst_icms?.id);
    setNcm(list?.relationships?.ncm?.id);
    setCfop(list?.relationships?.cfop?.id);
    setStateOrigin(list?.relationships?.icms_origin_state?.id);
    setStateDestiny(list?.relationships?.icms_destiny_state?.id);
    setCustomer(list?.relationships?.icms_customer_type?.id);
    setIpi(list?.relationships?.cst_ipi?.id);
    setCstReasons(list?.relationships?.cst_ipi_reason?.id ?? 129);
    setCofins(list?.relationships?.cst_cofins?.id);
    setPis(list?.relationships?.cst_pis?.id);
    setWeight(list?.tax_weight?.toString() ?? '0');
    setAliquotIcms(list?.icms_aliquot?.toString() ?? '0');
    setMva(list?.icms_mva?.toString() ?? '0');
    setReduction(list?.icms_base_calc_reduction?.toString() ?? '0');
    setAliquotIpi(list?.ipi_aliquot?.toString() ?? '0');
    setAliquotPis(list?.pis_aliquot?.toString() ?? '0');
    setAliquotCofins(list?.cofins_aliquot?.toString() ?? '0');
    setIcmsAliquotDeferral(list?.icms_aliquot_deferral?.toString() ?? '0');
    setIcmsCredit(list?.icms_credit?.toString() ?? '0');
    setNcm_origin(list?.ncm_origin);
  };

  const handlePerfil = (e: any) => {
    setTaxProfile(e?.value);

    if (e?.value) {
      completeTaxProfileInformationTax(e?.value);
    } else {
      clearInfoFicais();
    }
  };

  return (
    <Layout title="Informações Fiscais">
      <Row>
        <p>
          {' '}
          Selecione um perfil fiscal para preencher automaticamente todas as
          informações fiscais do produto.
        </p>
      </Row>
      <S.Wrapper>
        <ReactSelect
          label="Perfil fiscal"
          placeholder="Perfil fiscal"
          isClearable
          options={taxProfiles?.data?.map((item: any) => ({
            value: item.id,
            label: item.tax_profile_name,
            store_id: item.store_id,
          }))}
          state={taxProfile}
          onChange={(e: any) => handlePerfil(e)}
          isLoading={isLoadingTaxProfile}
        />
      </S.Wrapper>
      <div className={styles.line} />
      <S.Wrapper>
        <InputDefault
          label="Peso"
          placeholder="0,00 Kg"
          type="number"
          autoComplete="off"
          step="0.01"
          min="0"
          state={weight}
          setState={setWeight}
        />

        <ReactSelect
          label="Tipo"
          placeholder="Tipo"
          isClearable
          options={invoiceTypes?.data?.map((item: any) => ({
            value: item.id,
            label: item.tax_invoice_type_description,
            store_id: item.store_id,
          }))}
          state={types}
          setState={setTypes}
          isLoading={isLoadingInvoiceTypes}
          isDisabled={isLoadingInvoiceTypes}
        />

        <ReactSelect
          label="Origem"
          placeholder="Selecione a origem"
          isClearable
          options={cstOrigins?.data?.map((item: any) => ({
            value: item.id,
            label: item.cst_origin_description,
            store_id: item.store_id,
          }))}
          state={origins}
          setState={setOrigins}
          isLoading={isLoadingCstOrigins}
          isDisabled={isLoadingCstOrigins}
        />

        <NcmSelect
          label="NCM"
          state={ncm}
          setState={setNcm}
          placeholder="Pesquise seu NCM"
          isInvalid={validNcm}
          cests={cests}
          cest={cest}
          setCestListObject={setCestListObject}
        />
        {cestListObject?.length > 0 && (
          <ReactSelect
            label="CEST"
            placeholder="CEST"
            isClearable
            options={cestListObject?.map((item: any) => ({
              value: item?.id,
              label: item?.cest_code,
            }))}
            state={cest}
            setState={setCest}
            isDisabled={loading}
            isLoading={isLoadingCests}
          />
        )}
        <ReactSelect
          label="CFOP"
          placeholder="CFOP"
          isClearable
          options={cfops?.data?.map((item: any) => ({
            value: item.id,
            label: `${item.cfop} - ${normalizeDescricao(item.descricao_cfop)}`,
            store_id: item.store_id,
          }))}
          state={cfop}
          setState={setCfop}
          isInvalid={validCfop}
          isLoading={isLoadingCfops}
          isDisabled={isLoadingCfops}
        />
      </S.Wrapper>

      <span style={{ fontWeight: 'bold', padding: '0 20px', fontSize: '13px' }}>
        Origem do NCM
      </span>
      <S.Wrapper4>
        <InputCheckRadio
          text="Nacional"
          value="Nacional"
          state={ncm_origin}
          setState={setNcm_origin}
        />
        <InputCheckRadio
          text="Importado"
          value="Importado"
          state={ncm_origin}
          setState={setNcm_origin}
        />
        <InputCheckRadio
          text="Estatal"
          value="Estatal"
          state={ncm_origin}
          setState={setNcm_origin}
        />
        <InputCheckRadio
          text="Municipal"
          value="Municipal"
          state={ncm_origin}
          setState={setNcm_origin}
        />
      </S.Wrapper4>

      <div className={styles.line} />

      <Row className="mb-2">
        <Col
          className="spaceBetween"
          style={{ cursor: 'pointer', paddingRight: '1rem' }}
          onClick={() => setIcmsOpen(!icmsOpen)}
        >
          <h4>Criar Regra ICMS</h4>
          <div>
            {!icmsOpen ? (
              <IoIosArrowDown size={20} />
            ) : (
              <IoIosArrowUp size={20} />
            )}
          </div>
        </Col>
      </Row>
      {icmsOpen && (
        <>
          <S.Wrapper>
            <ReactSelect
              label="Origem"
              placeholder="UF"
              isClearable
              options={states?.data?.map((item: any) => ({
                value: item.id,
                label: item.state_initials,
                store_id: item.store_id,
              }))}
              state={stateOrigin}
              setState={setStateOrigin}
              isLoading={isLoadingStates}
              isDisabled={isLoadingStates}
            />

            <ReactSelect
              label="Destino"
              placeholder="UF"
              isClearable
              options={states?.data?.map((item: any) => ({
                value: item.id,
                label: item.state_initials,
                store_id: item.store_id,
              }))}
              state={stateDestiny}
              setState={setStateDestiny}
              isLoading={isLoadingStates}
              isDisabled={isLoadingStates}
            />

            <ReactSelect
              label="Tip. cliente"
              placeholder="Tipo de cliente"
              isClearable
              options={icmsCustomerTypes?.data?.map((item: any) => ({
                value: item.id,
                label: item.icms_customer_type_description,
                store_id: item.store_id,
              }))}
              state={customer}
              setState={setCustomer}
              isLoading={isLoadingIcmsCustomerTypes}
              isDisabled={isLoadingIcmsCustomerTypes}
            />

            <InputDefault
              label="MVA"
              placeholder="0,00"
              type="number"
              autoComplete="off"
              step="0.01"
              min="0"
              state={mva}
              setState={setMva}
            />

            <InputDefault
              label="Diferimento"
              placeholder="0,00"
              type="number"
              autoComplete="off"
              step="0.01"
              min="0"
              state={icmsAliquotDeferral}
              setState={setIcmsAliquotDeferral}
            />

            <InputDefault
              label="Cálc. crédito"
              placeholder="0,00"
              type="number"
              autoComplete="off"
              step="0.01"
              min="0"
              state={icmsCredit}
              setState={setIcmsCredit}
            />

            <InputDefault
              label="Redu. calculo"
              placeholder="0,00"
              type="number"
              autoComplete="off"
              step="0.01"
              min="0"
              state={reduction}
              setState={setReduction}
            />
          </S.Wrapper>
        </>
      )}

      <div className={styles.line} />

      <Row className="mb-2">
        <Col className="spaceBetween">
          <h4>IPI</h4>
        </Col>
      </Row>

      <S.Wrapper>
        <ReactSelect
          label="Sit. tributária"
          placeholder="Situação tributária"
          isClearable
          options={ipisList?.map((item: any) => ({
            value: item.id,
            label: `${item.cst_code} - ${item.cst_description}`,
            store_id: item.store_id,
          }))}
          state={ipi}
          setState={setIpi}
          isInvalid={validIpi}
          isLoading={isLoadingCstsIpi}
          isDisabled={isLoadingCstsIpi}
        />

        <InputDefault
          label="Aliq. IPI"
          placeholder="0,00"
          type="number"
          autoComplete="off"
          step="0.01"
          min="0"
          state={aliquotIpi}
          setState={setAliquotIpi}
          isInvalid={validAliquotIpi}
        />

        <ReactSelect
          label="Enqu.de IPI"
          placeholder="Enquadramento de ipi"
          isClearable
          options={cstReasonsList?.data?.map((item: any) => ({
            value: item.id,
            label: `${item.reason_code} - ${item.reason_description}`,
            store_id: item.store_id,
          }))}
          state={cstReasons}
          setState={setCstReasons}
          isLoading={isLoadingCstReasons}
          isDisabled={isLoadingCstReasons}
          isInvalid={selfService && validcstReasons}
        />
      </S.Wrapper>

      <div className={styles.line} />

      <Row className="mb-2">
        <Col className="spaceBetween">
          <h4>PIS e COFINS</h4>
        </Col>
      </Row>

      <S.Wrapper2>
        {/* SELECT DE PIS - Agora usando pisList filtrado */}
        <ReactSelect
          label="CST PIS"
          placeholder="Selecione o CST de PIS"
          isClearable
          options={pisList?.map((item: any) => ({
            value: item.id,
            label: `${item.cst_code} - ${item.cst_description}`,
            store_id: item.store_id,
          }))}
          state={pis}
          setState={setPis}
          isInvalid={validPis}
          isLoading={isLoadingCstsPis}
          isDisabled={isLoadingCstsPis}
        />

        <InputDefault
          label="Alíquota PIS"
          placeholder="0,00"
          type="number"
          autoComplete="off"
          step="0.01"
          min="0"
          state={aliquotPis}
          setState={setAliquotPis}
          isInvalid={validAliquotPis}
        />

        {/* SELECT DE COFINS - Agora usando cofinsList filtrado */}
        <ReactSelect
          label="CST COFINS"
          placeholder="Selecione o CST de COFINS"
          isClearable
          options={cofinsList?.map((item: any) => ({
            value: item.id,
            label: `${item.cst_code} - ${item.cst_description}`,
            store_id: item.store_id,
          }))}
          state={cofins}
          setState={setCofins}
          isInvalid={validCofins}
          isLoading={isLoadingCstsCofins}
          isDisabled={isLoadingCstsCofins}
        />

        <InputDefault
          label="Alíquota COFINS"
          placeholder="0,00"
          type="number"
          autoComplete="off"
          step="0.01"
          min="0"
          state={aliquotCofins}
          setState={setAliquotCofins}
        />

        {/* SELECT DE ICMS/CSOSN */}
        <ReactSelect
          label="CST/CSOSN"
          placeholder="CSOSN(Código de situação de operação do Simples Nacional)"
          isClearable
          options={CSOSNList?.map((item: any) => ({
            value: item.id,
            label: `${item.cst_code} - ${item.cst_description}`,
            store_id: item.store_id,
          }))}
          state={icms}
          setState={setIcms}
          isInvalid={validIcms}
          isLoading={isLoadingCstsIcms}
          isDisabled={isLoadingCstsIcms}
        />

        <InputDefault
          label="Alíquota ICMS"
          placeholder="Alíquota do ICMS do Simples Nacional"
          type="number"
          autoComplete="off"
          step="0.01"
          min="0"
          state={aliquot}
          setState={setAliquotIcms}
          isInvalid={validAliquot}
        />
      </S.Wrapper2>
    </Layout>
  );
}